import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PageHeader from "@core/components/pageHeader";
import DonationTypeList from "views/pages/donationtype/DonationTypeList";
import AddDonationType from "views/pages/donationtype/AddDonationType";
import APICall from "network/APICall";
import EndPoints from "network/Endpoints";
import { useLocation } from "react-router-dom";
import Utility from "@core/helper/utility";
import { useSelector } from "react-redux";
import Loader from "@core/helper/Loader";

const DonationType = () => {
  const [openModal, setOpenModal] = useState(false);
  const [type, setType] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [donationList, setDonationList] = useState([]);
  const [pageSize, setPageSize] = useState(10);

  const [pageNumber, setPageNumber] = useState(0);
  const [updateData, setUpdateData] = useState(null);
  const [totalRecord, setTotalRecord] = useState(0);
  const [permission, setPermission] = useState({});
  const { userData } = useSelector((state) => state.auth);
  const [role, setRole] = useState("");
  const location = useLocation();
  useEffect(() => {
    if (userData.data.user.role === "2") {
      const donationtype = Utility.getUserData({
        datastore: userData,
        activePath: location.pathname,
      });

      setPermission(donationtype[1]);
    } else {
      setPermission({});
    }

    setRole(userData.data.user.role);
  }, [location.pathname, userData]);
  const handleDeleteModal = (id) => {
    if (id) {
      const payload = { id };
      APICall("delete", payload, EndPoints.deleteDonationType)
        .then((response) => {
          const { isError, message } = response.data;
          if (response.status === 200 && !isError) {
            toast.success(message);
            const filter = donationList.filter((o) => o.id !== id);
            setDonationList(filter);
            fetchDonationType();
          }
        })
        .catch((error) => {
          return error;
        });
    }
    setDeleteOpen(!deleteOpen);
  };

  const handleOpen = (type, id) => {
    setOpenModal(!openModal);
    setType(type);
    if (id) {
      const findList = donationList.find((o) => o.id === id);
      setUpdateData(findList);
    }
  };

  useEffect(() => {
    fetchDonationType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, pageNumber]);

  const fetchDonationType = () => {
    Loader.isLoading(true);

    const payload = {
      pageNo: pageNumber + 1,
      limit: pageSize,
      orderBy: "ASC",
    };
    APICall("post", payload, EndPoints.getDonationType)
      .then((response) => {
        const { results, totalCount } = response.data.data;
        if (response.status === 200 && results) {
          setDonationList(results);
          setTotalRecord(totalCount);
        } else {
          setDonationList([]);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        Loader.isLoading(false);
      });
  };

  const submitDonationType = () => {
    fetchDonationType();
  };

  const handleDonationStatusChange = (status, id, checkType) => {
    const payload = {
      id: id,
    };
    if (checkType === "status") {
      payload.status = status;
    } else {
      payload.enabledHome = status;
    }

    APICall("post", payload, EndPoints.changeDonationTypeStatus)
      .then((response) => {
        const { isError, message } = response.data;
        if (isError) {
          toast.error(message);
          return;
        }
        toast.success(message);
        fetchDonationType();
      })
      .catch((error) => {
        return error;
      });
  };

  return (
    <Grid container spacing={4}>
      <PageHeader
        title={
          <Typography variant="body1" sx={{ fontSize: "1.3rem !important" }}>
            Donation Type
          </Typography>
        }
      />
      {((permission.view && role === "2") || role === "1") && (
        <Grid item xs={12}>
          <DonationTypeList
            handleDeleteModal={handleDeleteModal}
            deleteOpen={deleteOpen}
            handleOpen={handleOpen}
            donationList={donationList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            handleDonationStatusChange={handleDonationStatusChange}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            totalRecord={totalRecord}
            permission={permission}
            role={role}
          />
        </Grid>
      )}
      <AddDonationType
        open={openModal}
        toggle={handleOpen}
        type={type}
        heading={type === "edit" ? "Update Donation Type" : "Add Donation Type"}
        onSubmitDonation={submitDonationType}
        updateData={updateData}
        permission={permission}
        role={role}
      />
    </Grid>
  );
};

export default DonationType;
